import axios from 'axios';

const KAKAO_REST_KEY = "dda666088941d52fda46c9aba9abb928";
const AUTH = { headers: { "Authorization": "KakaoAK " + KAKAO_REST_KEY } };

// 장소 검색 (카카오 키워드 검색) — 응답 x=경도, y=위도
export const searchAddress = (query, succFunc) => {
    let url = "https://dapi.kakao.com/v2/local/search/keyword.json?query=" + encodeURIComponent(query);

    axios.get(url, AUTH)
        .then((response) => {
            if (succFunc && response.data && response.data.documents) {
                let results = response.data.documents.map((d) => {
                    let addr = d.road_address_name || d.address_name;
                    return {
                        display_name: addr ? d.place_name + " - " + addr : d.place_name,
                        lat: String(d.y),
                        lon: String(d.x)
                    };
                });
                succFunc(results);
            }
        })
        .catch((err) => {
            console.error("카카오 장소검색 error:", err);
        });
};

// 역지오코딩 (x=경도, y=위도) — 카카오 coord2regioncode, 행정동 기준 마지막 문서 사용
export const getAddress = (x, y, succFunc) => {
    let url = "https://dapi.kakao.com/v2/local/geo/coord2regioncode.json?x=" + x + "&y=" + y;

    axios.get(url, AUTH)
        .then((response) => {
            let resp = response.data;
            if (succFunc && resp && resp.documents && resp.documents.length > 0) {
                let doc = resp.documents[resp.documents.length - 1];
                succFunc({
                    address_name: doc.address_name,
                    display_name: doc.address_name
                });
            }
        })
        .catch((err) => {
            console.error("카카오 역지오코딩 error:", err);
        });
};
